import ENV_VARS from '@/config'
import { get, post, del, put } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

export const getTimelines = get(`${BACKEND_SERVER}/web/timeline`, { noLoading: true })
export const getNextTimelines = get(`${BACKEND_SERVER}/web/timeline/page/%pageNumber%`, {
  noLoading: true
})

export const getEvents = get(`${BACKEND_SERVER}/timeline/%timelineRoomId%/next/%lastEventId%`, {
  noLoading: true
})
export const getEventsUp = get(
  `${BACKEND_SERVER}/timeline/%timelineRoomId%/next/%lastEventId%/up`,
  {
    noLoading: true
  }
)
export const getEventsDown = get(
  `${BACKEND_SERVER}/timeline/%timelineRoomId%/next/%lastEventId%/down`,
  {
    noLoading: true
  }
)
export const getTimelineSearch = post(`${BACKEND_SERVER}/timeline/search`, {
  noLoading: true
})
export const getSupportRoom = get(`${BACKEND_SERVER}/timeline/support_rooms`, { noLoading: true })
export const getSecureFile = get(`${BACKEND_SERVER}/secure/chat/%fileId%`, {
  responseType: 'blob'
})
export const sendInviteToApply = post(
  `${BACKEND_SERVER}/timeline/%timelineRoomId%/invite/application`,
  { noLoading: true }
)

export const sendIdVerificationRequest = post(
  `${BACKEND_SERVER}/timeline/%timelineRoomId%/invite/identification/verify`,
  { noLoading: true }
)

export const sendListingVerificationRequest = post(
  `${BACKEND_SERVER}/timeline/%timelineRoomId%/invite/listing/verify`,
  { noLoading: true }
)

export const hidePhoneNumber = put(`${BACKEND_SERVER}/users/phone/hide`, { noLoading: true })

export const unhidePhoneNumber = put(`${BACKEND_SERVER}/users/phone/unhide`, { noLoading: true })

export const sendMessage = post(`${BACKEND_SERVER}/timeline/%timelineRoomId%`, {
  noLoading: true
})
export const sendImage = post(`${BACKEND_SERVER}/timeline/%timelineRoomId%/upload/img`)
export const sendFile = post(`${BACKEND_SERVER}/timeline/%timelineRoomId%/upload/secure`)

export const getStats = get(`${BACKEND_SERVER}/timeline/stats/extended`, {
  noLoading: true
})
export const setTimelineRead = get(`${BACKEND_SERVER}/timeline/%timelineRoomId%/read`, {
  noLoading: true
})
export const tenantStartChat = post(`${BACKEND_SERVER}/timeline/listings/%listingId%`)

export const deleteTimeline = del(`${BACKEND_SERVER}/timeline/%timelineRoomId%`)

export const addTimelineToFavourites = put(`${BACKEND_SERVER}/timeline/%timelineRoomId%/favourites`)

export const removeTimelineToFavourites = del(
  `${BACKEND_SERVER}/timeline/%timelineRoomId%/favourites`
)

export const reportProblem = post(`${BACKEND_SERVER}/problem_reports/create`)

export const getTimelinesQueryString = get(`${BACKEND_SERVER}/web/timeline?%queryString%`, {
  noLoading: true
})

export const getNextTimelinesQueryString = get(
  `${BACKEND_SERVER}/web/timeline/page/%pageNumber%/?%queryString%`,
  {
    noLoading: true
  }
)

export const loadTimeline = get(`${BACKEND_SERVER}/web/timeline/%timelineId%`, { noLoading: true })

export const bulkTimelineMarkAsRead = put(`${BACKEND_SERVER}/timeline/bulk/read`, {
  noLoading: true
})

export const bulkTimelineDelete = put(`${BACKEND_SERVER}/timeline/bulk/delete`, {
  noLoading: true
})
